import React, { useState, useContext, useEffect } from "react";
import ActionsContext from "common/ActionsContext";
import Modal from "common/Modal.jsx";

const ActiveFlowsHelpModal = () => {
  const [open, setOpen] = useState(false);
  const actions = useContext(ActionsContext);

  const doClose = () => setOpen(false);

  useEffect(() => {
    return actions.recv("open-help", function () {
      setOpen(true);
    });
  }, []);
  return open !== true ? null : (
    <Modal
      title="Active Flows"
      onClose={doClose}
      content={() => (
        <>
          <p>Currently active connections, broken down by type:</p>
          <ul>
            <li>
              <b>TCP-Handshake</b>: TCP flows (connections) being established
              (in initial handshake).
            </li>
            <li>
              <b>TCP-Established</b>: TCP flows established and being optimized.
            </li>
            <li>
              <b>TCP-Tracking</b>: TCP flows established and not being optimized
              (simply tracked to obtained metrics).
            </li>
            <li>
              <b>TCP-Other</b>: Rest of TCP flows (for example, being finished
              or not being optimized nor tracked).
            </li>
            <li>
              <b>UDP-All</b>: All of UDP flows.
            </li>
            <li>
              <b>IPOther-All</b>: Rest of IP flows.
            </li>
          </ul>
          <p>
            Click on the coloured dots on top-right corner of the graph to
            optionally select and de-select which types of flows are shown.
          </p>
          <p>
            Double-click on the coloured dots on top-right corner of the graph
            to optionally isolate the selected type of flow.
          </p>
          <p>
            Click on the <i className="material-icons valign-icon">refresh</i>{" "}
            icon to refresh the number of active flows.
          </p>
        </>
      )}
    />
  );
};
export default ActiveFlowsHelpModal;
